import Vue from "vue";

const templateId = +document.body.getAttribute("data-tplId") || +document.body.getAttribute("tplid");
const templatePath = "./templates/" + templateId + "/multiselect.js";

let component = Vue.component("multiselect", function(resolve, reject) {
  import(`${templatePath}`).then(res => {
    resolve({
      template: res.default,
      props:['opt'],
      data() {
        return {
          templateId:templateId,
          isLabel:false,
          multisel:[],
          optSort:[],
          closed: false,
          count: 5,
          defaultCount: 5
        }
      },
      computed:{
        labelclasstrue(){
          if (this.templateId > 35)
            return 'ok-form-label form-label -state-active'
          return 'col-md-12 ok-label-static'
        },
        labelclassfalse(){
          if (this.templateId > 35)
            return 'ok-form-label form-label'
          return 'col-md-12 ok-label-static -state-empty'
        },
        optLength() {
          return this.opt.options.length
        },
        showMore() {
          return this.optLength > this.count ? true : false
        }
      },
      created(){
        let arrSelected = []
        let arrNotSelected = []
        const urlParams = new URLSearchParams(window.location.search)
        this.multisel = urlParams.getAll(this.opt.name+'[]')
        this.opt.options.forEach(el => {
          if (this.multisel.includes(`${el.id}`)) {
            arrSelected.push(el)
          } else {
            arrNotSelected.push(el)
          }
        })
        if (arrSelected.length > this.defaultCount) {
          this.defaultCount = arrSelected.length
          this.count = arrSelected.length
        }
        this.$nextTick(() => {
          this.optSort = [...arrSelected, ...arrNotSelected]
        })
        this.closed = window.vueMultiselectClosed
      },
      watch: {
        multisel() {
          if (!this.multisel || this.multisel.length===0) {
            return this.isLabel=false;
          } else {
            return this.isLabel=true;}
        }
      },
      methods:{
        toggleOptions(){
          this.closed = !this.closed
        },
        toogleShowMore(){
          this.count === this.optLength ? this.count = this.defaultCount : this.count = this.optLength
        }
      }
    })
  })
})
export default component;



// WEBPACK FOOTER //
// ./src/components/multiselect.js